<template>
  <div class="manager-info" v-loading="nowLoading">
    <el-form class="form" :model="formData" :rules="rules" label-position="top" ref="formRef" inline>
      <div class="content-title">基本信息</div>
      <div v-if="managerInfo.reviewStatus == 4" class="cancel-tag">已注销</div>
      <el-form-item label="经营类别" prop="manageType" class="w-p-100">
        <el-radio-group v-model="formData.manageType">
          <el-radio :label="1">个人经营</el-radio>
          <el-radio :label="2">单位经营</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="isCompany" label="单位名称" prop="companyName" class="w-p-50-d-10">
        <el-input v-model="formData.companyName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item v-if="isCompany" label="社会信用代码" prop="companyCreditCode" class="w-p-50-d-10">
        <el-input v-model="formData.companyCreditCode" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item v-if="isCompany" label="单位联系电话" prop="companyPhone" class="w-p-50-d-10">
        <el-input v-model="formData.companyPhone" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="经营人" prop="realManagerName" class="w-p-50-d-10">
        <el-input v-model="formData.realManagerName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="国籍" prop="realManagerCountry" class="w-p-25-d-10">
        <el-select v-model="formData.realManagerCountry" :clearable="false">
          <el-option v-for="item in countryList" :key="item.name" :value="item.name" :label="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件类型" prop="realManagerCertType" class="w-p-25-d-10">
        <el-select v-model="formData.realManagerCertType" :clearable="false">
          <el-option v-for="item in certTypeList" :key="item.name" :value="item.name" :label="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件号码" prop="realManagerCertCode" class="w-p-50-d-10">
        <el-input v-model="formData.realManagerCertCode" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="外文姓" prop="realManagerLastName" class="w-p-50-d-10">
        <el-input v-model="formData.realManagerLastName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="外文名" prop="realManagerFirstName" class="w-p-50-d-10">
        <el-input v-model="formData.realManagerFirstName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="realManagerPhone" class="w-p-50-d-10">
        <el-input v-model="formData.realManagerPhone" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="实际居住地" prop="realManagerAddr" class="w-p-50-d-10">
        <el-input v-model="formData.realManagerAddr" placeholder="请输入"></el-input>
      </el-form-item>

      <template v-if="isCompany">
        <div class="content-title">法人信息</div>
        <el-form-item label="法人" prop="corporationName" class="w-p-50-d-10">
          <el-input v-model="formData.corporationName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="法人联系电话" prop="corporationPhone" class="w-p-50-d-10">
          <el-input v-model="formData.corporationPhone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="法人外文姓" prop="corporationLastName" class="w-p-50-d-10">
          <el-input v-model="formData.corporationLastName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="法人外文名" prop="corporationFirstName" class="w-p-50-d-10">
          <el-input v-model="formData.corporationFirstName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="法人国籍" prop="corporationCountry" class="w-p-50-d-10">
          <el-select class="w-p-100" v-model="formData.corporationCountry" :clearable="false">
            <el-option v-for="item in countryList" :key="item.name" :value="item.name" :label="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="法人证件种类" prop="corporationCertType" class="w-p-50-d-10">
          <el-select class="w-p-100" v-model="formData.corporationCertType" :clearable="false">
            <el-option v-for="item in certTypeList" :key="item.name" :value="item.name" :label="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="法人证件号码" prop="corporationCertCode" class="w-p-50-d-10">
          <el-input v-model="formData.corporationCertCode" placeholder="请输入"></el-input>
        </el-form-item>
      </template>
      <div class="bottom-btn">
        <el-button class="color-orange" type="primary" v-loading="btnLoading" @click="handleConfirm">{{ managerInfo.id ? '更新信息' : '保存信息' }}</el-button>
        <el-button v-if="formData.id && managerInfo.reviewStatus != 4" class="color-danger" type="primary" @click="handleCancel">注销</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import formCheck from "@/components/common/formCheck";

export default {
  mixins: [formCheck],
  props: {
    userInfo: {
      type: Object,
      default: () => ({})
    },
    managerInfo: {
      type: [Object, String],
      default: () => ({})
    }
  },
  watch: {
    'managerInfo.id'(val){
      if(val) this.setFormData();
    }
  },
  data() {
    return {
      nowLoading: false,
      btnLoading: false,

      formData: {
        id: '',
        manageType: 1, // 经营类别
        companyName: '', // 单位名称
        companyCreditCode: '', // 社会信用代码
        companyPhone: '', // 单位联系电话
        realManagerName: '', // 经营人
        realManagerCountry: '156', // 国籍
        realManagerCertType: '111', // 证件类型
        realManagerCertCode: '', // 证件号码
        realManagerLastName: '', // 外文姓
        realManagerFirstName: '', // 外文名
        realManagerPhone: '', // 联系电话
        realManagerAddr: '', // 实际居住地
        corporationName: '', // 法人
        corporationPhone: '', // 法人联系电话
        corporationLastName: '', // 法人外文姓
        corporationFirstName: '', // 法人外文名
        corporationCountry: '156', // 法人国籍
        corporationCertType: '111', // 法人证件种类
        corporationCertCode: '', // 法人证件号码
      },
      rules: {
        companyName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' },
        ],
        companyCreditCode: [
          { required: true, message: '请输入社会信用代码', trigger: 'blur' },
          { validator: this.checkSocialCode, trigger: 'blur' },
        ],
        companyPhone: [
          { validator: this.checkTel, trigger: 'blur' },
        ],
        corporationPhone: [
          { validator: this.checkTel, trigger: 'blur' },
        ],
        realManagerName: [
          { required: true, message: '请输入经营人', trigger: 'blur' },
        ],
        realManagerCountry: [
          { required: true, message: '请选择国籍', trigger: 'change' },
        ],
        realManagerCertType: [
          { required: true, message: '请选择证件类型', trigger: 'change' },
        ],
        realManagerCertCode: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
          { validator: this.checkIDCardCode, trigger: 'blur' },
        ],
        realManagerPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: this.checkTel, trigger: 'blur' },
        ],
        corporationCertCode: [
          { validator: this.checkIDCardCode, trigger: 'blur' },
        ]
      },

      countryList: [],
      certTypeList: [],
    }
  },
  computed: {
    // 是单位经营
    isCompany() {
      return this.formData.manageType == 2
    }
  },
  created() {
    let types = ['certType', 'countryCode']
    let typeRelation = [
      { typeName: 'certType', propName: 'certTypeList' },
      { typeName: 'countryCode', propName: 'countryList' },
    ]
    this.getDictData({ types, typeRelation }, undefined, () => {
      if (this.managerInfo.id) {
        this.setFormData();
      }
    })
  },
  methods: {
    ...mapActions(['fetchData']),
    setFormData(){
      console.log('setFormData');
      for (let key in this.formData) {
        this.formData[key] = this.managerInfo[key] || this.formData[key]
      }
    },
    // 获取经营者信息，并重新载入页面
    getManagerInfo() {
      let url = 'MANAGER.GET_LIST'
      let params = {
        pageNumber: 1,
        pageSize: 1
      };

      this.nowLoading = true
      this.fetchData({ url, method: "get", params }).then((res) => {
        if (res.rowCount) {
          let manager = res?.data[0] || ''
          if (!manager) return

          localStorage.setItem('manager', JSON.stringify(manager))
          location.reload()
        }
      }).finally(() => {
        this.nowLoading = false
      });
    },
    // 确认操作
    handleConfirm() {
      this.$refs.formRef.validate(pass => {
        if (pass) {
          this.saveOrUpdate()
        } else {
          this.$message.error('请按要求填写信息')
        }
      })
    },
    // 处理注销 - 原型跟UI又对不上了
    handleCancel() {
      this.$confirm('确认注销？', '温馨提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        let url = 'MANAGER.POST_SAVE_OR_UPDATE'
        let headers = { 'Content-Type': 'application/json' }
        let params = {
          id: this.formData.id,
          reviewStatus: 4
        }

        this.btnLoading = true
        this.fetchData({ url, method: 'post', params, headers, flag: true }).then(res => {
          if (res.code == 200) {
            this.$message.success('注销成功！')
            this.getManagerInfo()
          } else {
            this.$message.error(res.msg || '注销失败！')
          }
        }).finally(() => {
          this.btnLoading = false
        })
      })
    },
    // 保存 或 更新经营者信息
    saveOrUpdate() {
      let text = this.formData.id ? '更新' : '保存'
      let url = 'MANAGER.POST_SAVE_OR_UPDATE'
      let headers = { 'Content-Type': 'application/json' }
      let params = JSON.parse(JSON.stringify(this.formData))
      if (!params.id) {
        delete params.id
      } else {
        params.reviewStatus = 1
      }

      this.btnLoading = true
      this.fetchData({ url, method: "post", params, headers, flag: true }).then((res) => {
        if (res.code == 200) {
          this.$message.success(`${text}成功`)
          // 如果当前是新增，那么需要重新加载页面
          if (!params.id) {
            this.getManagerInfo()
          }
        } else {
          this.$message.error(res.msg || `${text}失败`)
        }
      }).finally(() => {
        this.btnLoading = false
      });
    },
    // 获取字典数据
    getDictData(opts, cb, finalCB) {
      let url = 'RESOURCE.GET_MULTI_LIST'
      let params = opts.types.map(item => `types=${item}`).join('&')

      this.nowLoading = true
      this.fetchData({ url, method: "get", params, isGetParamsDirect: true }).then((res) => {
        if (!res) {
          return this.$message.error('字典获取失败');
        }
        for (let key in res) {
          for (let i = 0; i < opts.typeRelation.length; i++) {
            if (key === opts.typeRelation[i].typeName) {
              this[opts.typeRelation[i].propName] = res[key]
            }
          }
        }

        cb && cb()
      }).finally(() => {
        finalCB && finalCB()
        this.nowLoading = false
      });
    },
  }
}
</script>

<style lang="less" scoped>
@colorOrange: rgba(246, 100, 1, 1);

.manager-info {
  width: 100%;
  padding-bottom: 100px;
  background-color: white;
  .content-title {
    margin: 20px 0px;
    width: 100%;
    font-size: 12px;
    color: @colorOrange;
  }
  .form {
    position: relative;
    justify-content: space-between;
    margin: 0 auto;
    width: 800px;
  }
  .cancel-tag {
    position: absolute;
    top: 50px;
    right: 20px;
    padding: 8px 30px;
    font-size: 18px;
    color: #F56C6C;
    border: 2px solid #F56C6C;
    border-radius: 3px;
    transform: rotate(30deg);
  }
  .bottom-btn {
    margin-top: 50px;
    text-align: center;
    width: 100%;
  }
  :deep(.el-form-item) {
    margin-right: 15px;
  }
}

.color-orange {
  background-color: @colorOrange;
}
.color-danger {
  background-color: #F56C6C;
}
.w-p-25-d-10 {
  width: calc(~"25% - 15px");
}
.w-p-50-d-10 {
  width: calc(~"50% - 15px");
}
</style>